import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import OutboxOutlinedIcon from "@mui/icons-material/OutboxOutlined";
import MoveToInboxOutlinedIcon from "@mui/icons-material/MoveToInboxOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link } from "react-router-dom";
import Container from "../../UI/Container";

const GRID_SIZE = { xs: 12, sm: 6 };

const MENU_ITEMS = [
  {
    titulo: "Enviados",
    descricao: "Crie, envie e acompanhe o engajamento dos comunicados.",
    link: "/comunicado",
    Icon: OutboxOutlinedIcon,
  },
  {
    titulo: "Recebidos",
    descricao: "Veja os comunicados que foram enviados para você.",
    link: "/comunicado-aluno",
    Icon: MoveToInboxOutlinedIcon,
  },
];

const ComunicadoMenu = () => {
  return (
    <Container>
      <Box mb={3}>
        <Typography variant="h6">Comunicados</Typography>
        <Typography variant="body2" color="text.secondary">
          Escolha quais comunicados você quer ver.
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {MENU_ITEMS.map(({ titulo, descricao, link, Icon }) => (
          <Grid key={link} size={GRID_SIZE}>
            <Card
              variant="outlined"
              sx={{
                height: "100%",
                transition: "box-shadow .2s, transform .2s",
                "&:hover": { boxShadow: 4, transform: "translateY(-2px)" },
              }}
            >
              <CardActionArea component={Link} to={link} sx={{ height: "100%" }}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box
                      sx={{
                        display: "flex",
                        p: 1.5,
                        borderRadius: 2,
                        bgcolor: "action.hover",
                        color: "secondary.main",
                      }}
                    >
                      <Icon fontSize="large" />
                    </Box>
                    <Box flexGrow={1}>
                      <Typography variant="subtitle1" fontWeight={600}>
                        {titulo}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {descricao}
                      </Typography>
                    </Box>
                    <ChevronRightIcon color="action" />
                  </Stack>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ComunicadoMenu;
